export default __webpack_public_path__ + "static/resources-summer-workshop-d06e77e92f84d15446f0f00c703c7acb.jpg";